<template>
	<div class="header" :class="{'hide':hideHeader}">
		<div class="logo" @click="test(3)">
			<Marquee class="mq" :val="companyName" ></Marquee>
			<img v-if="logoImg" class="logoPic" :src="logoImg" />
			<div v-else class="logoErr errorFonts_mini">
				<div>暂无图片</div>
			</div>
		</div>
		<div class="check">
			<el-tooltip
				placement="bottom-start"
				:class="item.links.indexOf($route.path.substr(1))== -1 ? '' : 'active'"
				v-for="(item, index) in topList"
				:key="index"
				v-show="(!item.limits)||$common.hasLimits(item.limits)"
				:disabled="!item.allowPopover"
				v-model="item.opening"
				>
				<div slot="content" class="ttstyle">
					<div v-for="(ch,index2) in item.child" :key="index2" @click="topage2(ch.url,item)" class="popstyle">{{ch.name}}</div>
				</div>
				
				<div v-if="item.allowPopover" class="checkList">
					<i class="iconfont" v-html="item.icon"></i>
					<div class="notice_txt">{{ item.name }}</div>
				</div>
				<div v-else @click="toPage(item.link,item.limits)" class="checkList">
					<i class="iconfont" v-html="item.icon"></i>
					<div class="notice_txt">{{ item.name }}</div>
				</div>
			</el-tooltip>
		</div>
		<div>
			<div class="notice" @click="toNotice" :class="noticeLinks.indexOf($route.path.substr(1))== -1 ? '' : 'active'">
				<i class="iconfont">&#xe609;</i>
				<div class="notice_txt">公告</div>
			</div>
		</div>
	</div>
</template>


<script>
import Marquee from './marquee'
export default {
	props:{
		hideHeader:{
			type:Boolean,
			default:false,
		}
	},
	components:{
		Marquee,
	},
	name: "navTop",
	data() {
		return {
			GLOBAL:this.$global,
			logoImg:"",
			companyName:"",
			topList: [
				// {
				// 	icon: "&#xeb0a;",
				// 	name: "首页",
				// 	link: "/main",
				// 	links:["main"],
				// },
				{
					icon: "&#xe604;",
					name: "产品",
					link: "/product",
					links:["product","favorites","goodsInfo"],
					allowPopover:false,
					child:[],
					opening:false,
				},
				{
					icon: "&#xe648;",
					name: "订货",
					link: "/order",
					links:["order","orderSummary","send","addProSend","addSend","sendDetail"],
					limits:'order',
					allowPopover:false,
					child:[],
					opening:false,
				},
				{
					icon: "&#xe9b2;",
					name: "财务",
					link: "/payment",
					links:["payment","customReport","needReport"],
					limits:'paymentList',
					allowPopover:false,
					child:[],
					opening:false,
				},
				{
					icon: "&#xe610;",
					name: "客户",
					link: "/customer",
					links:["customer"],
					limits:'customerList',
					allowPopover:false,
					child:[],
					opening:false,
				},
				{
					icon: "&#xe634;",
					name: "库存",
					link: "/store",
					links:["store","storeDetail","storeSummary","storeEnter","storeExit","storeChange"],
					limits:'stockReport',
					allowPopover:false,
					child:[],
					opening:false,
				},
				{
					icon: "&#xe9b2;",
					name: "采购",
					link: "/purchase",
					links:["purchase","refund","purchaseSummary","purchaseAdd","purchaseDetail","refundAdd","ppick","addPick","pEnter","addEnter"],
					limits:'materialOrder',
					allowPopover:false,
					child:[],
					opening:false,
				},
			],
			noticeLinks:['message','sysMessageDetail'],
		};
	},
	created() {
		this.checkHeader();
		this.$api.getCompanyBasic().then((res)=>{
			if(res.data.code==1){
				let info = res.data.data;
				if(info.logo){
					this.logoImg = this.$api.baseURL+info.logo;
				}
				this.companyName = info.name;
				window.document.title = info.ipadName?info.ipadName:'顺通ERP系统';
			}
		})
	},

	methods: {
		checkHeader:function(){
			//订货
			if(this.$common.hasLimits('order')){
				let ordertag = this.topList[1];
				if(this.$common.hasLimits("orderSendItemDetail")){
					ordertag.child.unshift({name:'销售详细',url:'/sendDetail'});
				}
				if(this.$common.hasLimits("orderSendInfo")){
					ordertag.child.unshift({name:'销售单',url:'/send'});
				}
				if(this.$common.hasLimits('orderSend')){
					ordertag.child.unshift({name:'新增发货',url:'/addSend'});
				}
				if(this.$common.hasLimits('orderSend')){
					ordertag.child.unshift({name:'新增产品发货',url:'/addProSend'});
				}
				if(this.$common.hasLimits("orderStaticisByCust")||this.$common.hasLimits("orderStaticisByEmp")||this.$common.hasLimits("orderStaticisByProd")){
					ordertag.child.unshift({name:'订单统计',url:'/orderSummary'});
				}
				if(ordertag.child.length>0){
					ordertag.child.unshift({name:'订货单',url:'/order'});
					ordertag.allowPopover = true;
				}
			}
			//财务
			if(this.$common.hasLimits('paymentList')){
				let ordertag = this.topList[2];
				if(this.$common.hasLimits('other')){
					ordertag.child.unshift({name:'收支记录',url:'/otherReport'});
				}
				if(this.$common.hasLimits('report')){
					ordertag.child.unshift({name:'应收报表',url:'/needReport'});
				}
				if(this.$common.hasLimits('customerReport')){
					ordertag.child.unshift({name:'客户对账单',url:'/customReport'});
				}
				if(ordertag.child.length>0){
					ordertag.child.unshift({name:'收款记录',url:'/payment'});
					ordertag.allowPopover = true;
				}
			}
			if(this.$global.userType==1){
				let ordertag = this.topList[2];
				ordertag.link = '/customReport'
			}
			//库存
			if(this.$common.hasLimits('stockReport')){
				let ordertag = this.topList[4];
				if(this.$common.hasLimits('allocation')){
					ordertag.child.unshift({name:'库存调拨',url:'/storeChange'});
				}
				if(this.$common.hasLimits('outRecord')){
					ordertag.child.unshift({name:'商品出库',url:'/storeExit'});
				}
				if(this.$common.hasLimits('inRecord')){
					ordertag.child.unshift({name:'商品入库',url:'/storeEnter'});
				}
				if(this.$common.hasLimits('recordSum')){
					ordertag.child.unshift({name:'出入库汇总',url:'/storeSummary'});
				}
				if(this.$common.hasLimits('recordReport')){
					ordertag.child.unshift({name:'出入库明细',url:'/storeDetail'});
				}
				if(ordertag.child.length>0){
					ordertag.child.unshift({name:'库存明细',url:'/store'});
					ordertag.allowPopover = true;
				}
			}
			if(this.$common.hasLimits('materialOrderDetail')){
				let ordertag = this.topList[5];
				if(false){
					ordertag.child.unshift({name:'Bom清单',url:'/Bom'});
				}
				if(false){
					ordertag.child.unshift({name:'原材料库存',url:'/pStock'});
				}
				if(this.$common.hasLimits('receiveOut')){
					ordertag.child.unshift({name:'领料出库',url:'/ppick'});
				}
				if(this.$common.hasLimits('materialIn')){
					ordertag.child.unshift({name:'材料入库',url:'/pEnter'});
				}
				if(this.$common.hasLimits('materialRecord')){
					ordertag.child.unshift({name:'采购出入库',url:'/purchaseSummary'});
				}
				if(this.$common.hasLimits('materialReturn')){
					ordertag.child.unshift({name:'采购退货单',url:'/refund'});
				}
				if(this.$common.hasLimits('materialOrderDetail')||this.$common.hasLimits("materialReturnDetail")){
					ordertag.child.unshift({name:'采购单明细',url:'/purchaseDetail'});
				}
				if(this.$common.hasLimits('materialOrder')){
					ordertag.child.unshift({name:'采购单',url:'/purchase'});
				}
				if(ordertag.child.length>0){
					ordertag.allowPopover = true;
				}
			}
		},
		toPage(link,limits){
			if(limits!=null){
				if(!this.$common.checkLimits(limits)){
					return;
				}
			}
			this.$router.push(link);
		},
		topage2(link,obj){
			obj.opening = false;
			this.$router.push(link);
		},
		toNotice(){
			this.$router.push("/message");
		},
		test(val){
			if(this.GLOBAL.userType==1){
				return;
			}
			this.$router.push("/statistics");
			// this.$router.push("/panel3");
		}
	},
};
</script>

<style lang="scss" scoped>
.logoPic{
	width: 50px;
	height: 50px;
	position: absolute;
	top: 5px;
	left: 5px;
	object-fit: contain;
}
.logoErr{
	width: 40px;
	height: 40px;
	padding: 5px;
	position: absolute;
	top: 5px;
	left: 5px;
}
.header.hide{
	height: 0px;
}
.header {
	background-color: #333940;
	height: 60px;
	width: 100%;
	color: #fff;
	box-sizing: border-box;
	padding: 0 30px;
	box-shadow: 0px 0px 5px 0px rgba(20, 23, 26, 0.3);
	display: flex;
	align-items: center;
	justify-content: space-between;
	position: fixed;
	z-index: 999;
	overflow: hidden;
	transition-duration: 0.25s;
	.check {
		display: flex;
		height: 60px;
		.checkList {
			display: flex;
			height: 60px;
			line-height: 60px;
			align-items: center;
			justify-content: center;
			margin-right: 5px;
			padding: 0 5px;
			outline: 0 !important;
			cursor: pointer;

			.iconfont {
				margin-right: 8px;
				font-size: 22px;
			}
		}
	}
	.active {
		background: #292e33;
		color: #1f8fff;
	}

	@media (orientation: portrait) {
		.mq{
			margin-left: 40px;
			width: 120px;
			font-weight: bold;
		}
		.notice_txt{
			display: none;
		}
	}

	@media (orientation: landscape) {
		.mq{
			margin-left: 40px;
			width: 200px;
			font-weight: bold;
		}
		.notice_txt{
			font-size: 14px;
		}
	}
	.notice {
		display: flex;
		align-items: center;
		box-sizing: border-box;
		font-size: 14px;
		padding: 4px 13px;
		cursor: pointer;
		border: 1px solid #667280;
		border-radius: 25px;
		.iconfont {
			margin-right: 8px;
		}
	}
}
.ttstyle{
	width: 120px;
	padding: 0px 10px;
}
.popstyle{
	height: 36px;
	line-height: 36px;
	font-size: 16px;
}
.popstyle:hover{
	color: #1f8fff;
	cursor: pointer;
}
</style>
